import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '嫩小兔玩偶', path: '/category' },
      { label: '嫩小兔周边', path: '/category' },
      { label: '联名产品', path: '/category' },
      { label: '限定礼盒', path: '/category' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '常见问题', path: '/about' },
      { label: '玩偶养护', path: '/article/plush-toy-care-guide' },
      { label: '送礼指南', path: '/article/gift-guide-valentine' },
      { label: '收藏指南', path: '/article/collectors-guide' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌故事', path: '/article/nenxiaotu-brand-story' },
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-2xl text-primary-500">嫩小兔</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              萌系潮流品牌，以软萌治愈为理念，<br />为年轻人带来温暖陪伴。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://weibo.com/nenxiaotu" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="https://www.xiaohongshu.com/user/profile/nenxiaotu" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-5 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 嫩小兔 NenXiaoTu. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}